import { AxiosRequestConfig } from 'axios'

const getStores = (): AxiosRequestConfig => ({
  url: '/stores',
  method: 'GET',
})

export { getStores }
